import { Controller } from "@hotwired/stimulus";

// Removes its own element, e.g. a modal appended to the page by a JS response.
// Unlike shared/_remove_overlay (which removes every .overlay on the page), it
// leaves other overlays, such as hidden Search & Filter panels, in place.
//
//   <div class="overlay" data-controller="removable">
//     <button type="button" data-action="removable#remove">…</button>
//   </div>
export default class extends Controller {
  remove(event) {
    event.preventDefault();
    this.element.remove();
  }
}
